import { render, staticRenderFns } from "./HandwriteSearch.vue?vue&type=template&id=05ae84ee&scoped=true&"
import script from "./HandwriteSearch.vue?vue&type=script&lang=js&"
export * from "./HandwriteSearch.vue?vue&type=script&lang=js&"
import style0 from "./HandwriteSearch.vue?vue&type=style&index=0&id=05ae84ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae84ee",
  null
  
)

export default component.exports